import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { EFSupportLeft } from '@/components/UI/svg/Support';
import { getDataList } from '@/constants/contactUs';
import seoconfig from '@/seoconfig/contact-us';
import { useGlobal } from '@/utils/useGlobal';
import EfLink from '@elem/ui/ef-link';
import css from './contactus.module.scss';
import useOpenAiChat from '@elem/compPage/chat/core/components/chat-icon/useOpenAiChat';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
        <g clipPath="url(#clip0_2247_250)">
            <path
                d="M8 15.75H3.5C3.30109 15.75 3.11032 15.671 2.96967 15.5303C2.82902 15.3897 2.75 15.1989 2.75 15V9C2.75 8.80109 2.82902 8.61032 2.96967 8.46967C3.11032 8.32902 3.30109 8.25 3.5 8.25H8L14.75 3V21L8 15.75Z"
                stroke="#E27B00"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 8.25V15.75" stroke="#E27B00" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18.5 10.0171C18.9825 10.5649 19.2487 11.2699 19.2487 11.9999C19.2487 12.7299 18.9825 13.4349 18.5 13.9827"
                stroke="#E27B00"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.2817 7.5C22.3886 8.73755 23.0006 10.3397 23.0006 12C23.0006 13.6603 22.3886 15.2624 21.2817 16.5"
                stroke="#E27B00"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_2247_250">
                <rect width="24" height="24" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export default function ContactUs({ lang, SEO }: any) {
    const { useRouter, isMobile } = useGlobal();
    const { locale = 'us' } = useRouter();
    const dataList = getDataList(locale);
    const { handleOpenChat } = useOpenAiChat();

    const handleOpenChatPage = () => {
        try {
            if (['us', 'ca', 'eu', 'de', 'jp'].includes(locale)) {
                handleOpenChat();
                return;
            } else {
                (window as any).Microsoft.Omnichannel.LiveChatWidget.SDK.startChat();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const genModuleContactUs = (locale: string) => {
        if (locale === 'ca' || locale === 'kr') {
            locale = 'us';
        }
        if (locale === 'de' || locale === 'fr') {
            locale = 'eu';
        }

        const item: any = dataList.find((item: any) => item.locale === locale);
        if (!item) return null;

        return (
            <div className="contactUs-box" key={lang[item.country]}>
                <h3 className="contactUs-type">
                    <EFSupportLeft />
                    <span>{lang[item.country]}</span>
                </h3>
                <ul className="contactUs-list">
                    <li className="left">
                        {item.key === 'community' ? (
                            <div className="item 1">
                                <h4>{lang.site_about_contact_facebook}:</h4>
                                <a href={item.link} aria-label={item.link} target="_blank" rel="noreferrer">
                                    {lang.facebook}
                                </a>
                            </div>
                        ) : (
                            item.address && (
                                <div className="item 1">
                                    <h4>{item.isShowRoom ? lang.showroom_address : lang.site_about_contact_address}:</h4>
                                    <p>{lang[item.address]}</p>
                                </div>
                            )
                        )}
                        <div className="item 2" style={{ display: item.dealtime ? 'block' : 'none' }}>
                            <h4>{lang.site_about_contact_deal_time}:</h4>
                            <p>{lang[item.dealtime]}</p>
                        </div>
                        {item.hours && (
                            <div className="item 3" style={{ display: item.key === 'community' ? 'none' : 'block' }}>
                                <h4>{lang.site_about_contact_office_hours}:</h4>
                                <p>{lang[item.hours]}</p>
                            </div>
                        )}
                        <div className="item 4" style={{ display: item.tel ? 'block' : 'none' }}>
                            <h4>{lang.site_about_contact_tel}:</h4>
                            <p>{lang[item.tel]}</p>
                        </div>
                        <div className="item 5" style={{ display: item.worktime ? 'block' : 'none' }}>
                            <h4>{lang.site_about_contact_work_time}:</h4>
                            <p>{lang[item.worktime]}</p>
                        </div>
                        <div className="item 6" style={{ display: item.serviceHours ? 'block' : 'none' }}>
                            <h4>{lang.site_about_contact_hotline}:</h4>
                            <p>{lang[item.serviceHours]}</p>
                        </div>
                        {['de', 'eu', 'uk', 'ph', 'fr', 'nl'].includes(locale) && (
                            <>
                                {locale !== 'de' && (
                                    <div className="item" style={{ display: item.hotline ? 'block' : 'none' }}>
                                        <h4>{lang.site_about_contact_hotline}:</h4>
                                        <p>{lang[item.hotline]}</p>
                                    </div>
                                )}
                                {locale === 'de' && (
                                    <div className="item" style={{ display: item.hotline ? 'block' : 'none' }}>
                                        <h4>{lang.site_new_hotline}:</h4>
                                        <p>{lang.site_new_hotline_val}</p>
                                    </div>
                                )}
                            </>
                        )}
                    </li>
                    <li className="right">
                        {item.supportList?.map((list: any, index: number) => (
                            <div className="item" key={lang[list.title] + Math.random()}>
                                <div>
                                    {lang[list.title]}:<br />
                                    {index == 0 && (
                                        <a aria-label={'chat with us'} target="_blank" rel="noreferrer" onClick={() => handleOpenChatPage()}>
                                            {lang.chat_with_us} <br />
                                        </a>
                                    )}
                                    {list?.subs && list.subs?.length > 0 ? (
                                        <>
                                            {list?.subs?.map((sub: any, k: number) => (
                                                <div className="support-community-sub" key={`${sub.link}_${k}`}>
                                                    <a
                                                        href={sub?.notEmail ? sub?.link : `mailto:${sub.value}`}
                                                        aria-label={sub.value}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {sub.value}
                                                    </a>
                                                    {sub?.tip && <p className="support-email-sub-tip">{lang[sub.tip]}</p>}
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        <>
                                            {list.value.includes('@') ? (
                                                <a
                                                    href={list.notEmail ? list.link : `mailto:${list.value}`}
                                                    aria-label={list.value}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    {list.value}
                                                </a>
                                            ) : isMobile ? (
                                                <a href={`tel:${list.value}`} rel="noreferrer">
                                                    {list.value}
                                                </a>
                                            ) : (
                                                <span className="number-text">{list.value}</span>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        ))}
                    </li>
                </ul>
            </div>
        );
    };

    return (
        <PageLayout>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={String(locale)} list={seoconfig.include} pathname={seoconfig.url} />
            <div className={`${css.contactus} container`}>
                <h1 className="title">{lang.site_about_title}</h1>
                {['ca', 'us'].includes(locale) && (
                    <div className="contactus-prompt">
                        <div className="contactus-icon">{icon}</div>
                        <span>
                            <span className="contactus-text">Be cautious of fraudulent activities falsely claiming to represent EcoFlow. </span>
                            <EfLink className="contactus-link" href="fraud-alerts">
                                Learn more {'>'}
                            </EfLink>
                        </span>
                    </div>
                )}

                {['us', 'ca', 'eu', 'de', 'fr', 'jp', 'kr'].includes(locale) && genModuleContactUs(locale)}

                {/* 0808 日本站仅保留日本 https://ecoflow.feishu.cn/docx/QqutdghPDoQyuKxtl6JcoWHznsf */}
                {!['us', 'ca', 'eu', 'de', 'fr', 'jp', 'kr'].includes(locale) &&
                    (locale === 'jp' ? [dataList[0]] : dataList)?.map((item: any) => (
                        <div className="contactUs-box" key={lang[item.country]}>
                            <h3 className="contactUs-type">
                                <EFSupportLeft />
                                <span>{lang[item.country]}</span>
                            </h3>
                            <ul className="contactUs-list">
                                <li className="left">
                                    {item.key === 'community' ? (
                                        <div className="item 1">
                                            <h4>{lang.site_about_contact_facebook}:</h4>
                                            <a href={item.link} aria-label={item.link} target="_blank" rel="noreferrer">
                                                {lang.facebook}
                                            </a>
                                        </div>
                                    ) : (
                                        item.address && (
                                            <div className="item 1">
                                                <h4>{item.isShowRoom ? lang.showroom_address : lang.site_about_contact_address}:</h4>
                                                <p>{lang[item.address]}</p>
                                            </div>
                                        )
                                    )}
                                    <div className="item 2" style={{ display: item.dealtime ? 'block' : 'none' }}>
                                        <h4>{lang.site_about_contact_deal_time}:</h4>
                                        <p>{lang[item.dealtime]}</p>
                                    </div>
                                    {item.hours && (
                                        <div className="item 3" style={{ display: item.key === 'community' ? 'none' : 'block' }}>
                                            <h4>{lang.site_about_contact_office_hours}:</h4>
                                            <p>{lang[item.hours]}</p>
                                        </div>
                                    )}
                                    <div className="item 4" style={{ display: item.tel ? 'block' : 'none' }}>
                                        <h4>{lang.site_about_contact_tel}:</h4>
                                        <p>{lang[item.tel]}</p>
                                    </div>
                                    <div className="item 5" style={{ display: item.worktime ? 'block' : 'none' }}>
                                        <h4>{lang.site_about_contact_work_time}:</h4>
                                        <p>{lang[item.worktime]}</p>
                                    </div>
                                    <div className="item 6" style={{ display: item.serviceHours ? 'block' : 'none' }}>
                                        <h4>{lang.site_about_contact_hotline}:</h4>
                                        <p>{lang[item.serviceHours]}</p>
                                    </div>
                                    {['de', 'eu', 'uk', 'ph', 'fr', 'nl'].includes(locale) && (
                                        <>
                                            {locale !== 'de' && (
                                                <div className="item" style={{ display: item.hotline ? 'block' : 'none' }}>
                                                    <h4>{lang.site_about_contact_hotline}:</h4>
                                                    <p>{lang[item.hotline]}</p>
                                                </div>
                                            )}
                                            {locale === 'de' && (
                                                <div className="item" style={{ display: item.hotline ? 'block' : 'none' }}>
                                                    <h4>{lang.site_new_hotline}:</h4>
                                                    <p>{lang.site_new_hotline_val}</p>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </li>
                                <li className="right">
                                    {item.supportList?.map((list: any, index: number) => (
                                        <div className="item" key={lang[list.title] + Math.random()}>
                                            <div>
                                                {lang[list.title]}:<br />
                                                {locale === 'ph' && index === 0 && (
                                                    <EfLink
                                                        className="item-link support-link"
                                                        onClick={() => {
                                                            handleOpenChat();
                                                        }}
                                                    >
                                                        {'Chat with us'} <br />
                                                    </EfLink>
                                                )}
                                                {list?.subs && list.subs?.length > 0 ? (
                                                    <>
                                                        {list?.subs?.map((sub: any, k: number) => (
                                                            <div className="support-community-sub" key={`${sub.link}_${k}`}>
                                                                <a
                                                                    href={sub?.notEmail ? sub?.link : `mailto:${sub.value}`}
                                                                    aria-label={sub.value}
                                                                    target="_blank"
                                                                    rel="noreferrer"
                                                                >
                                                                    {sub.value}
                                                                </a>
                                                                {sub?.tip && <p className="support-email-sub-tip">{lang[sub.tip]}</p>}
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    <>
                                                        {list.value.includes('@') ? (
                                                            <a
                                                                href={list.notEmail ? list.link : `mailto:${list.value}`}
                                                                aria-label={list.value}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                            >
                                                                {list.value}
                                                            </a>
                                                        ) : isMobile ? (
                                                            <a href={`tel:${list.value}`} rel="noreferrer">
                                                                {list.value}
                                                            </a>
                                                        ) : (
                                                            <span className="number-text">{list.value}</span>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </li>
                            </ul>
                        </div>
                    ))}
            </div>
        </PageLayout>
    );
}
